import { getSalesSpaceGroupFromIndex, getSalesSpaceGroupIndexFromLabel, getTurnoverFromIndex } from '../../../../config';

const isNumberEqual = (a, b) => parseInt(a, 10) === parseInt(b, 10);

export function applyChainFilter(units = [], chains = []) {
    if (!chains || chains.length === 0) return units;
    return units.filter(unit =>
        chains.some(chain => isNumberEqual(chain.chainCode, unit.chainCode) && chain.selected)
    );
}

export function applyTurnoverFilter(units = [], turnoverRange = [], type = 'retail') {
    if (type === 'foodservice' || !turnoverRange || turnoverRange.length !== 2) {
        return units;
    }

    const [minLabel, maxLabel] = turnoverRange;
    if (minLabel === 1 && maxLabel === 19) {
        return units;
    }

    return units.filter(unit => {
        const turnoverClass = parseInt(unit.turnoverClass, 10);
        return turnoverClass >= minLabel && turnoverClass <= maxLabel;
    });
}

export function applySalesSpaceFilter(units = [], salesSpaceGroups = [], type = 'retail') {
    if (type === 'foodservice' || !salesSpaceGroups || salesSpaceGroups.length !== 2) {
        return units;
    }

    const indexValues = getSalesSpaceGroupIndexFromLabel(salesSpaceGroups);
    const { minGroup, maxGroup } = getSalesSpaceGroupFromIndex(indexValues);

    return units.filter(unit => {
        const retailArea = unit.retailArea || 0;
        return retailArea >= minGroup.min && retailArea <= maxGroup.max;
    });
}

export function applySegmentFilter(units = [], segments = [], type = 'retail') {
    if (type !== 'foodservice' || !segments || segments.length === 0) {
        return units;
    }

    return units.filter(unit =>
        segments.some(segment => isNumberEqual(segment.typeCode, unit.typeCode) && segment.selected)
    );
}

export function applyIncludeExcludeFilter(units = [], includeExclude = [], originalUnits = []) {
    if (!includeExclude || includeExclude.length === 0) return units;

    const excludedIds = new Set(includeExclude.map(item => item.delfiId));

    const filteredUnits = units.filter(unit => unit && !excludedIds.has(unit.delfiId));

    const included = includeExclude.filter(item => item.include);
    if (included.length === 0) {
        return filteredUnits;
    }

    const originalLookup = new Map();
    [...originalUnits, ...units].forEach(unit => {
        if (unit && unit.delfiId && !originalLookup.has(unit.delfiId)) {
            originalLookup.set(unit.delfiId, unit);
        }
    });

    const seen = new Set(filteredUnits.map(unit => unit && unit.delfiId));
    const includedUnits = [];
    included.forEach(item => {
        const match = originalLookup.get(item.delfiId);
        if (match && !seen.has(match.delfiId)) {
            includedUnits.push(match);
            seen.add(match.delfiId);
        }
    });

    return [...filteredUnits, ...includedUnits];
}

/**
 * Hjälpfunktioner för filterkomponenter som arbetar med slider-index istället för labels
 */
export function turnoverLabelsFromIndex(values) {
    const { minGroup, maxGroup } = getTurnoverFromIndex(values);
    return [minGroup.label, maxGroup.label];
}

export function salesSpaceLabelsFromIndex(values) {
    const { minGroup, maxGroup } = getSalesSpaceGroupFromIndex(values);
    return [minGroup.label, maxGroup.label];
}

export function countActiveFilters(salesDistrictFilters) {
    if (!salesDistrictFilters) return 0;

    let count = 0;

    const { chains, turnovers, salesSpaceGroups, segments, unitsIncludeExclude } = salesDistrictFilters;

    if (Array.isArray(chains) && chains.some(c => !c.selected)) count++;

    if (Array.isArray(turnovers) && turnovers.length === 2) {
        const [min, max] = turnovers;
        if (min !== 1 || max !== 19) count++;
    }

    if (Array.isArray(salesSpaceGroups) && salesSpaceGroups.length === 2) {
        const [min, max] = salesSpaceGroups;
        if (min !== 1 || max !== 6) count++;
    }

    if (Array.isArray(segments) && segments.some(s => !s.selected)) count++;

    if (Array.isArray(unitsIncludeExclude) && unitsIncludeExclude.length > 0) count++;

    return count;
}

